export default __webpack_public_path__ + "static/media/graignes16.1aa5b1ad.jpg";